module.exports = __webpack_public_path__ + "img/drivers-img.f64158bd.png";